import React, { Fragment, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input } from "reactstrap";
import Loading from "../../Common/Loading";
import Testsmtp from "./TestSMTPConnection";
import { modalOptions } from "./Constants";
import Select from "react-select";
import { PROTNUMBER_LISTS, PROTOCOL_LISTS } from "../Dashboard/Constant";

const ModalContent = ({ isModalOpen,  closeModal, DetailsKey, IntegrationsKey, handleInputChange, errorMessage, showButtonLoading, connectAPI, buttonStatusValues,setIntegrationsKey }) => {
    let modalFields = [];
    let modalLable = [];

    useEffect(() => {
        handleOptionChange(PROTOCOL_LISTS[0], "protocol");
    }, [])

    if (modalOptions[DetailsKey] !== undefined) {
        const { fields, label } = modalOptions[DetailsKey];
        modalFields = fields;  
        modalLable = label;
    }
    
    const processDisabled = (field) => {
        let response = false;
        if(field && field.name === "port" && !!IntegrationsKey.protocol && IntegrationsKey.protocol === "ssl"){
            response = true;
        }
        return response;
    }

    const handleOptionChange = (e, name) => {
        if(name === "protocol"){
            handleInputChange(e, name);
            if(e.value === "ssl"){
                handleInputChange(PROTNUMBER_LISTS[0], "port");
            }
        }else{
            handleInputChange(e, name);
        }
    }

    return (
      <>
        { DetailsKey !== 'test_connect' ?  
          ( <Modal isOpen={isModalOpen}>
                <ModalHeader toggle={closeModal}>
                Connect {modalLable}
                </ModalHeader>
                <ModalBody className="int-modal">
                    {modalFields && modalFields.map((field, fieldIndex) => (
                        <Fragment key={fieldIndex}>
                            <Label>{field.label}</Label>
                            {field.type === "dropdown" ? (
                                <>
                                <Select
                                    placeholder={`Select ${field.label}`}
                                    name={field.name}
                                    className="mb-2"
                                    classNamePrefix="wa-select"
                                    value={
                                        field.options.find(option => option.value === IntegrationsKey[field.name]) || null
                                    }
                                    options={field.options}
                                    onChange={(e) => handleOptionChange(e, field.name)}
                                    isDisabled = {processDisabled(field)}
                                />
                                <div>{errorMessage && <span className="error">{errorMessage[field.name]}</span>}</div>
                                </>
                            ) : (
                                <div>
                                <Input
                                    className="mb-2"
                                    type={field.type}  // Directly setting the type
                                    name={field.name}
                                    value={IntegrationsKey[field.name] || ""}
                                    onChange={(e) => handleInputChange(e, field.name)}
                                    required
                                />
                                {field.desc && <span>{field.desc}</span>}
                                {errorMessage && <span className="error">{errorMessage[field.name]}</span>}
                                </div>
                            )}
                        </Fragment>
                    ))}
                    {typeof errorMessage === 'string' && errorMessage.trim() !== '' && (<div><em className="error">{errorMessage}</em></div>)}
                </ModalBody>
                <ModalFooter>
                    <Loading
                        showLoader={showButtonLoading}
                        mainContent={
                            <Fragment>
                                {isModalOpen && (
                                    <Button className="container-footer-save theme-bg-g" onClick={() => connectAPI(IntegrationsKey, buttonStatusValues)}>
                                        Connect
                                    </Button>
                                )}
                            </Fragment>
                        }
                    />
                </ModalFooter>
            </Modal>) : (<Testsmtp closeModal={closeModal}></Testsmtp>) 
        }
      </>
    );
};

export default ModalContent;
